import { jwtDecode } from 'jwt-decode';

export function isTokenValid(token) {
    if (!token) return false;

    try {
        const payload = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000); // segundos desde epoch

        const valido = payload.exp && payload.exp > currentTime;

        if (!valido) {
            localStorage.removeItem('jwt'); // Elimina token expirado automáticamente
        }

        return valido;
    } catch (e) {
        // Si ocurre cualquier error (token mal formado, etc)
        localStorage.removeItem('jwt'); // Limpiar token inválido
        return false;
    }
}
export function getRolesFromToken(token) {
    if (!token) return [];

    try {
        const decodedPayload = jwtDecode(token);
        return decodedPayload.roles || [];
    } catch (e) {
        console.error("Error decodificando el token:", e);
        return [];
    }
}

export function hasRole(token, role) {
    const roles = getRolesFromToken(token);
    return roles.includes(role);
}
